  <div *ngFor="let day of days; let i = index" class="day-round"
       data-cy="frequent-step-create-alert-week-day-container"
       [ngClass]="{'selected': day.selected}"
       (click)="onSelectDay(i)">
    {{ 'alert.days.letter.' + day.value | translate}}
  </div>
